/* eslint-disable */
(function subnavtab($, Drupal) {

  Drupal.behaviors.subnavtab = {
    attach: function(context, settings) {
    

      // Tkt#: 6301: When user clicks on clear link remove the action in the form.
      // Hack due to core view Ajax reset bug. https://www.drupal.org/project/better_exposed_filters/issues/2996297
      // https://www.drupal.org/project/drupal/issues/3346820
      $("button[id^='edit-reset']").on('click', function(e){
        e.preventDefault();
        var onlyUrl = window.location.href.replace(window.location.search,'');
        $('#views-exposed-form-species-directory-v2-block-1').attr('action', onlyUrl);
        $('#views-exposed-form-species-directory-v2-block-1').attr('method', 'post');
        $('#views-exposed-form-species-directory-v2-block-1').submit();
      }); 

       // Default SP Illustration
      $('.paragraph--view-mode--search-preview-image').each(function () {
        if ($(this).find('.field--name-field-dam-media').length == 0) {
          $(this).next().show();
        }
      });

      $('document').ready(function() {

        //for the about-us who we are tab. Styling the headers according to section id
        if ( $('#block-noaa-components-aboutusmeetourleadershiphead').length ) {
          $('#block-noaa-components-aboutusmeetourleadershiphead .leadership-list__header').css('background', '#007eb2');
        }
        
        if ( $('#block-noaa-components-aboutusmeetourleadershipregulations').length ) {
          $('#block-noaa-components-aboutusmeetourleadershipregulations .leadership-list__header').css('background', '#00467f');
        }

        if ( $('#block-noaa-components-aboutusmeetourleadershipscience').length ) {
          $('#block-noaa-components-aboutusmeetourleadershipscience .leadership-list__header').css('background', '#008391');
        }

        if ( $('#block-noaa-components-aboutusmeetourleadershipoperations').length ) {
          $('#block-noaa-components-aboutusmeetourleadershipoperations .leadership-list__header').css('background', '#625bc4');
        }

       // Ensure no pre-saved values are set on reload.
       if ($('.sf-profiles--view-embed').length) {
        $("#edit-field-region-vocab option:eq(0)").prop("selected", true);
        $("#edit-field-species-categories-vocab-1 option:eq(0)").prop("selected", true);
        $("#edit-field-species-categories-vocab option:eq(0)").prop("selected", true);
       }

        // Run loader graphic
        $('.pager__item--page, .form-submit, .pager__item--previous-link, .pager__item--next-link ').on('click', function() {
          
          $('.view-content').addClass('loader');
          $('.loader').css('height', $('.view-content').height());
          $('.views-row').fadeTo( 500, 0.05 );

        });
      })

      $('document').ajaxComplete(function() {
        $('.view-content').removeClass('loader');
      })
      
      if (!$('#sf_information').length) {
        if ($('#featured_profile').text().length) {
          $('.views-exposed-form').append('<div id="sf_information" >' + $('#featured_profile').text() + '</div>');
        }
      }
     

    },
  };


}(jQuery, Drupal, drupalSettings));
/* eslint-enable */
